module.exports = __webpack_public_path__ + "static/media/S32.064ffff2.png";